exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\r\n.form-group {\r\n     margin-bottom: 8px /* Default is 15*/\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/css/bootstrap-customizations.css
// module id = 112
// module chunks = 0